/**
 * Model groups are taken from:
 * https://developer.samsung.com/smarttv/develop/specifications/tv-model-groups.html
 */
import data_ from './samsungModelData.json';
const data = data_ as {
  TV_2026_PREMIUM1: string;
  TV_2026_PREMIUM2: string;
  TV_2026_STANDARD1: string;
  TV_2026_BASIC1: string;
  TV_2026_BASIC2: string;
  TV_2025_PREMIUM1: string;
  TV_2025_PREMIUM2: string;
  TV_2025_PREMIUM3: string;
  TV_2025_PREMIUM4: string;
  TV_2025_STANDARD1: string;
  TV_2025_BASIC1: string;
  TV_2025_BASIC2: string;
  TV_2025_BASIC3: string;
  TV_2024_PREMIUM1: string;
  TV_2024_PREMIUM2: string;
  TV_2024_PREMIUM4: string;
  TV_2024_PREMIUM5: string;
  TV_2024_PREMIUM6: string;
  TV_2024_STANDARD1: string;
  TV_2024_STANDARD2: string;
  TV_2024_STANDARD3: string;
  TV_2024_BASIC2: string;
  TV_2024_BASIC3: string;
  TV_2024_BASIC4: string;
  TV_2024_PREMIUM5_LIC: string;
  TV_2024_BASIC2_LIC: string;
  TV_2024_BASIC2_LIC2: string;
  TV_2023_PREMIUM1: string;
  TV_2023_PREMIUM2: string;
  TV_2023_PREMIUM3: string;
  TV_2023_PREMIUM4: string;
  TV_2023_PREMIUM5: string;
  TV_2023_STANDARD1: string;
  TV_2023_BASIC1: string;
  TV_2023_BASIC2: string;
  TV_2023_BASIC3: string;
  TV_2023_BASIC1_LIC: string;
  TV_2023_BASIC1_LIC2: string;
  TV_2022_PREMIUM1: string;
  TV_2022_PREMIUM2: string;
  TV_2022_PREMIUM3: string;
  TV_2022_PREMIUM4: string;
  TV_2022_PREMIUM5: string;
  TV_2022_STANDARD1: string;
  TV_2022_BASIC1: string;
  TV_2022_BASIC3: string;
  TV_2021_PREMIUM1: string;
  TV_2021_PREMIUM2: string;
  TV_2021_PREMIUM3: string;
  TV_2021_STANDARD1: string;
  TV_2021_BASIC1: string;
  TV_2021_BASIC4_LIC: string;
  TV_2020_PREMIUM: string;
  TV_2020_STANDARD: string;
  TV_2020_BASIC1: string;
  TV_2020_BASIC2: string;
  TV_2019_PREMIUM: string;
  TV_2019_STANDARD: string;
  TV_2019_BASIC1: string;
  TV_2019_BASIC2: string;
  TV_2018_PREMIUM: string;
  TV_2018_STANDARD1: string;
  TV_2018_STANDARD2: string;
  TV_2018_STANDARD3: string;
  TV_2017_PREMIUM: string;
  TV_2017_STANDARD: string;
  TV_2017_ENTRY_CN1: string;
  TV_2016_PREMIUM: string;
  TV_2016_STANDARD1: string;
  TV_2016_STANDARD2: string;
  TV_2015_PREMIUM: string;
  TV_2015_STANDARD1: string;
  TV_2015_STANDARD2: string;
  TV_2015_ENTRY: string;
  TV_2014_PREMIUM: string;
  TV_2014_STANDARD1: string;
  TV_2014_STANDARD2: string;
  TV_2014_STANDARD3: string;
  TV_2014_ENTRY: string;
  TV_2013_PREMIUM: string;
  TV_2013_STANDARD: string;
  TV_2013_ENTRY: string;
  TV_2012_7Group: string;
  TV_2012_6Group: string;
  TV_2012_MFM_6Group: string;
  TV_2012_ENTRY: string;
  TV_2024_UNKN: string;
  TV_2023_UNKN: string;
  TV_2022_UNKN: string;
  TV_2021_UNKN: string;
  TV_2020_UNKN: string;
  TV_2019_UNKN: string;
  TV_2018_UNKN: string;
  TV_UNKN: string;
};

const modelGroupStringToList = (model: string): string[] =>
  model.split(',').map((s) => s.trim());

const SAMSUNG_TV_MODELS_MAP: Record<keyof typeof data, string[]> = {
  /** 2026 */
  TV_2026_PREMIUM1: modelGroupStringToList(data.TV_2026_PREMIUM1),
  TV_2026_PREMIUM2: modelGroupStringToList(data.TV_2026_PREMIUM2),
  TV_2026_STANDARD1: modelGroupStringToList(data.TV_2026_STANDARD1),
  TV_2026_BASIC1: modelGroupStringToList(data.TV_2026_BASIC1),
  TV_2026_BASIC2: modelGroupStringToList(data.TV_2026_BASIC2),

  /** 2025 */
  TV_2025_PREMIUM1: modelGroupStringToList(data.TV_2025_PREMIUM1),
  TV_2025_PREMIUM2: modelGroupStringToList(data.TV_2025_PREMIUM2),
  TV_2025_PREMIUM3: modelGroupStringToList(data.TV_2025_PREMIUM3),
  TV_2025_PREMIUM4: modelGroupStringToList(data.TV_2025_PREMIUM4),
  TV_2025_STANDARD1: modelGroupStringToList(data.TV_2025_STANDARD1),
  TV_2025_BASIC1: modelGroupStringToList(data.TV_2025_BASIC1),
  TV_2025_BASIC2: modelGroupStringToList(data.TV_2025_BASIC2),
  TV_2025_BASIC3: modelGroupStringToList(data.TV_2025_BASIC3),

  /** 2024 */
  TV_2024_PREMIUM1: modelGroupStringToList(data.TV_2024_PREMIUM1),
  TV_2024_PREMIUM2: modelGroupStringToList(data.TV_2024_PREMIUM2),
  TV_2024_PREMIUM4: modelGroupStringToList(data.TV_2024_PREMIUM4),
  TV_2024_PREMIUM5: modelGroupStringToList(data.TV_2024_PREMIUM5),
  TV_2024_PREMIUM6: modelGroupStringToList(data.TV_2024_PREMIUM6),
  TV_2024_STANDARD1: modelGroupStringToList(data.TV_2024_STANDARD1),
  TV_2024_STANDARD2: modelGroupStringToList(data.TV_2024_STANDARD2),
  TV_2024_STANDARD3: modelGroupStringToList(data.TV_2024_STANDARD3),
  TV_2024_BASIC2: modelGroupStringToList(data.TV_2024_BASIC2),
  TV_2024_BASIC3: modelGroupStringToList(data.TV_2024_BASIC3),
  TV_2024_BASIC4: modelGroupStringToList(data.TV_2024_BASIC4),
  TV_2024_PREMIUM5_LIC: modelGroupStringToList(data.TV_2024_PREMIUM5_LIC),
  TV_2024_BASIC2_LIC: modelGroupStringToList(data.TV_2024_BASIC2_LIC),
  TV_2024_BASIC2_LIC2: modelGroupStringToList(data.TV_2024_BASIC2_LIC2),

  /** 2023 */
  TV_2023_PREMIUM1: modelGroupStringToList(data.TV_2023_PREMIUM1),
  TV_2023_PREMIUM2: modelGroupStringToList(data.TV_2023_PREMIUM2),
  TV_2023_PREMIUM3: modelGroupStringToList(data.TV_2023_PREMIUM3),
  TV_2023_PREMIUM4: modelGroupStringToList(data.TV_2023_PREMIUM4),
  TV_2023_PREMIUM5: modelGroupStringToList(data.TV_2023_PREMIUM5),
  TV_2023_STANDARD1: modelGroupStringToList(data.TV_2023_STANDARD1),
  TV_2023_BASIC1: modelGroupStringToList(data.TV_2023_BASIC1),
  TV_2023_BASIC2: modelGroupStringToList(data.TV_2023_BASIC2),
  TV_2023_BASIC3: modelGroupStringToList(data.TV_2023_BASIC3),
  TV_2023_BASIC1_LIC: modelGroupStringToList(data.TV_2023_BASIC1_LIC),
  TV_2023_BASIC1_LIC2: modelGroupStringToList(data.TV_2023_BASIC1_LIC2),

  /** 2022 */
  TV_2022_PREMIUM1: modelGroupStringToList(data.TV_2022_PREMIUM1),
  TV_2022_PREMIUM2: modelGroupStringToList(data.TV_2022_PREMIUM2),
  TV_2022_PREMIUM3: modelGroupStringToList(data.TV_2022_PREMIUM3),
  TV_2022_PREMIUM4: modelGroupStringToList(data.TV_2022_PREMIUM4),
  TV_2022_PREMIUM5: modelGroupStringToList(data.TV_2022_PREMIUM5),
  TV_2022_STANDARD1: modelGroupStringToList(data.TV_2022_STANDARD1),
  TV_2022_BASIC1: modelGroupStringToList(data.TV_2022_BASIC1),
  TV_2022_BASIC3: modelGroupStringToList(data.TV_2022_BASIC3),

  /** 2021 */
  TV_2021_PREMIUM1: modelGroupStringToList(data.TV_2021_PREMIUM1),
  TV_2021_PREMIUM2: modelGroupStringToList(data.TV_2021_PREMIUM2),
  TV_2021_PREMIUM3: modelGroupStringToList(data.TV_2021_PREMIUM3),
  TV_2021_STANDARD1: modelGroupStringToList(data.TV_2021_STANDARD1),
  TV_2021_BASIC1: modelGroupStringToList(data.TV_2021_BASIC1),
  TV_2021_BASIC4_LIC: modelGroupStringToList(data.TV_2021_BASIC4_LIC),

  /** 2020 */
  TV_2020_PREMIUM: modelGroupStringToList(data.TV_2020_PREMIUM),
  TV_2020_STANDARD: modelGroupStringToList(data.TV_2020_STANDARD),
  TV_2020_BASIC1: modelGroupStringToList(data.TV_2020_BASIC1),
  TV_2020_BASIC2: modelGroupStringToList(data.TV_2020_BASIC2),

  /** 2019 */
  TV_2019_PREMIUM: modelGroupStringToList(data.TV_2019_PREMIUM),
  TV_2019_STANDARD: modelGroupStringToList(data.TV_2019_STANDARD),
  TV_2019_BASIC1: modelGroupStringToList(data.TV_2019_BASIC1),
  TV_2019_BASIC2: modelGroupStringToList(data.TV_2019_BASIC2),

  /** 2018 */
  TV_2018_PREMIUM: modelGroupStringToList(data.TV_2018_PREMIUM),
  TV_2018_STANDARD1: modelGroupStringToList(data.TV_2018_STANDARD1),
  TV_2018_STANDARD2: modelGroupStringToList(data.TV_2018_STANDARD2),
  TV_2018_STANDARD3: modelGroupStringToList(data.TV_2018_STANDARD3),

  /** 2017 */
  TV_2017_PREMIUM: modelGroupStringToList(data.TV_2017_PREMIUM),
  TV_2017_STANDARD: modelGroupStringToList(data.TV_2017_STANDARD),
  TV_2017_ENTRY_CN1: modelGroupStringToList(data.TV_2017_ENTRY_CN1),

  /** 2016 */
  TV_2016_PREMIUM: modelGroupStringToList(data.TV_2016_PREMIUM),
  TV_2016_STANDARD1: modelGroupStringToList(data.TV_2016_STANDARD1),
  TV_2016_STANDARD2: modelGroupStringToList(data.TV_2016_STANDARD2),

  /** 2015 */
  TV_2015_PREMIUM: modelGroupStringToList(data.TV_2015_PREMIUM),
  TV_2015_STANDARD1: modelGroupStringToList(data.TV_2015_STANDARD1),
  TV_2015_STANDARD2: modelGroupStringToList(data.TV_2015_STANDARD2),
  TV_2015_ENTRY: modelGroupStringToList(data.TV_2015_ENTRY),

  /** 2014 and older */
  TV_2014_PREMIUM: modelGroupStringToList(data.TV_2014_PREMIUM),
  TV_2014_STANDARD1: modelGroupStringToList(data.TV_2014_STANDARD1),
  TV_2014_STANDARD2: modelGroupStringToList(data.TV_2014_STANDARD2),
  TV_2014_STANDARD3: modelGroupStringToList(data.TV_2014_STANDARD3),
  TV_2014_ENTRY: modelGroupStringToList(data.TV_2014_ENTRY),
  TV_2013_PREMIUM: modelGroupStringToList(data.TV_2013_PREMIUM),
  TV_2013_STANDARD: modelGroupStringToList(data.TV_2013_STANDARD),
  TV_2013_ENTRY: modelGroupStringToList(data.TV_2013_ENTRY),
  TV_2012_7Group: modelGroupStringToList(data.TV_2012_7Group),
  TV_2012_6Group: modelGroupStringToList(data.TV_2012_6Group),
  TV_2012_MFM_6Group: modelGroupStringToList(data.TV_2012_MFM_6Group),
  TV_2012_ENTRY: modelGroupStringToList(data.TV_2012_ENTRY),

  /** Unknown model groups */
  TV_2024_UNKN: modelGroupStringToList(data.TV_2024_UNKN),
  TV_2023_UNKN: modelGroupStringToList(data.TV_2023_UNKN),
  TV_2022_UNKN: modelGroupStringToList(data.TV_2022_UNKN),
  TV_2021_UNKN: modelGroupStringToList(data.TV_2021_UNKN),
  TV_2020_UNKN: modelGroupStringToList(data.TV_2020_UNKN),
  TV_2019_UNKN: modelGroupStringToList(data.TV_2019_UNKN),
  TV_2018_UNKN: modelGroupStringToList(data.TV_2018_UNKN),
  TV_UNKN: modelGroupStringToList(data.TV_UNKN)
};

export type SamsungTVModelGroups = keyof typeof SAMSUNG_TV_MODELS_MAP;

export const SAMSUNG_TV_MODELS = Object.keys(
  SAMSUNG_TV_MODELS_MAP
) as SamsungTVModelGroups[];

export const extractSamsungTVModelGroup = (
  model: string
): SamsungTVModelGroups | null => {
  for (let i = 0; i <= SAMSUNG_TV_MODELS.length; i += 1) {
    const thisModelListKey = SAMSUNG_TV_MODELS[i];
    const thisModelList = SAMSUNG_TV_MODELS_MAP[thisModelListKey];
    if (thisModelList && thisModelList.includes(model)) {
      return thisModelListKey;
    }
  }

  return null;
};
